import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';
import Wrapper from 'src/components/common/wrapper';
import JoinForm from 'src/components/form/joinForm';

const JoinPage = () => {
  return (
    <Wrapper width="md">
      <Helmet>
        <title>SMUVE </title>
      </Helmet>
      <Typography sx={{ mb: 3 }} variant="h4" color={'primary'}>
        Welcome to SMUVE
      </Typography>
      <JoinForm />
    </Wrapper>
  );
};

export default JoinPage;
